import { render, staticRenderFns } from "./ActionFooter.vue?vue&type=template&id=6f416b78"
import script from "./ActionFooter.vue?vue&type=script&lang=js"
export * from "./ActionFooter.vue?vue&type=script&lang=js"
import style0 from "./ActionFooter.vue?vue&type=style&index=0&id=6f416b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports